import React, {useState} from "react";
import {usePage} from "@inertiajs/react";
import {Button} from "react-bootstrap";
import SupportTicketModal from "./SupportTicketModal.jsx";
import SharedAccountHint from "./SharedAccountHint.jsx";
import supportCowboy from "../../../images/support-cowboy.png";

/**
 * Der Support-Knopf in der Kopfleiste. Er wird über die headerControls in die
 * linke Nav der Kopfleiste eingehängt; das ms-auto schiebt ihn dort ans rechte
 * Ende - optisch direkt links neben den Benutzernamen. Anders als die
 * Cronjob-Bedienelemente ist er für ALLE angemeldeten Benutzer sichtbar.
 * Icon + Beschriftung statt nacktem Symbol: Der Knopf soll als Einladung
 * lesbar sein, nicht als Deko-Icon, das niemand deutet.
 */
export default function SupportHeaderControl() {
    const {supportButtonEnabled, isSharedSupportAccount} = usePage().props;
    const [show, setShow] = useState(false);
    const [sharedHint, setSharedHint] = useState(false);

    // Freischaltung über die Einstellungen (Bereich "Support"). Solange sie
    // aus ist, gibt es die Schaltfläche gar nicht erst.
    if (!supportButtonEnabled) {
        return null;
    }

    // Der Sammelzugang der Probearbeiter darf keine Tickets erstellen (ein
    // Ticket bräuchte einen eindeutigen Melder) - statt des Formulars gibt es
    // nur den Hinweis dazu, siehe SharedAccountHint.
    const handleClick = () => {
        if (isSharedSupportAccount) {
            setSharedHint(true);
            return;
        }
        setShow(true);
    };

    return (
        <div className="ms-auto d-flex align-items-center">
            <Button
                variant="outline-secondary"
                size="sm"
                className="d-inline-flex align-items-center gap-1 support-header-button"
                title="Problem melden oder Verbesserungsvorschlag einreichen"
                onClick={handleClick}
            >
                <img
                    alt=""
                    aria-hidden="true"
                    className="flex-shrink-0"
                    height="21"
                    src={supportCowboy}
                    width="21"
                />
                <span className="d-none d-lg-inline">Support</span>
            </Button>
            <SupportTicketModal show={show} onHide={() => setShow(false)} />
            <SharedAccountHint show={sharedHint} onClose={() => setSharedHint(false)} />
        </div>
    );
}
